export default __webpack_public_path__ + "static/media/emoji-facebook.a1ebb0a1.svg";